'use strict';

exports.__esModule = true;

var _objectHash = require('./objectHash');

var _objectHash2 = _interopRequireDefault(_objectHash);

var _constants = require('./constants');

var _ViasPromise = require('./ViasPromise');

var _ViasPromise2 = _interopRequireDefault(_ViasPromise);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Model = function () {
  function Model(name) {
    var aliases = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _this = this;

    var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var custom = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Model);

    this.name = name;
    // Cache: alias name -> alias key -> document
    this.docs = {};
    this.aliases = aliases;
    this.listeners = [];
    this.customResults = {};

    this.methods = methods;
    this.custom = custom;

    // Only cache document when at least one alias is available to act as a key
    this.cachable = Object.keys(aliases).length > 0;

    // Get operation, request should return one document
    this.get = function (alias, key, options) {
      if (!methods.get) {
        throw new Error('Get method is not implemented');
      }

      if (!_this.cachable) {
        throw new Error('No alias set up');
      }

      var exec = function () {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var cb = arguments[1];

        var docFromCache = _this.fromCache(alias, key, options.expiry || 0, options.sync);
        if (docFromCache) {
          return cb(null, { alias: alias, result: key });
        }

        // Do not fetch from remote if sync options is flagged and nothing can be found in cached
        // Used for server-side-rendeing and first time data consume for front-end
        if (options.sync) {
          return cb();
        }

        methods.get(alias, key, options, function (err, doc) {
          if (err) {
            return cb(err);
          }

          if (!doc) {
            return cb(null, { alias: alias });
          }

          if (key !== doc[_this.aliases[alias]]) {
            throw new Error('Document received has inconsistent value for path ' + _this.aliases[alias] + ', expect ' + key + ' but got ' + doc[_this.aliases[alias]]);
          }

          _this.save(doc, new Date());
          cb(null, { alias: alias, result: key });
          _this._broadcast(_constants.MODEL_CACHE_UPDATED);
        });
      };

      return new _ViasPromise2.default(_this, 'get', { alias: alias, key: key }, options, _constants.DOCUMENT_SHAPE, exec);
    };

    // Bulk operation, request should return array of document
    this.bulk = function (alias) {
      var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (!methods.bulk) {
        throw new Error('Bulk method is not implemented');
      }

      if (!_this.cachable) {
        throw new Error('No alias set up');
      }

      var exec = function () {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var cb = arguments[1];

        var keysToGet = [];
        var result = {};
        var resultKeys = [];
        // Get available document from cache
        // Only get unavailable doc from remote
        for (var _iterator = keys, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
          var _ref;

          if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
          } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
          }

          var key = _ref;

          var docFromCache = _this.fromCache(alias, key, options.expiry || 0, options.sync);
          if (docFromCache) {
            result[key] = docFromCache;
            resultKeys.push(key);
          } else {
            keysToGet.push(key);
          }
        }

        if (keysToGet.length === 0) {
          return cb(null, { alias: alias, result: resultKeys });
        }

        if (options.sync) {
          return cb();
        }

        methods.bulk(alias, keysToGet, options, function (err, remoteResult) {
          if (err) {
            return cb(err);
          }
          var fetchedAt = new Date();
          for (var _iterator2 = remoteResult, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray2) {
              if (_i2 >= _iterator2.length) break;
              _ref2 = _iterator2[_i2++];
            } else {
              _i2 = _iterator2.next();
              if (_i2.done) break;
              _ref2 = _i2.value;
            }

            var doc = _ref2;

            _this.save(doc, fetchedAt);
            var path = _this.aliases[alias];
            var key = (0, _util.pathValue)(doc, path);
            resultKeys.push(key);
          }

          cb(null, { alias: alias, result: resultKeys });
          _this._broadcast(_constants.MODEL_CACHE_UPDATED);
        });
      };

      var keysObj = {};
      for (var _iterator3 = keys, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
        var _ref3;

        if (_isArray3) {
          if (_i3 >= _iterator3.length) break;
          _ref3 = _iterator3[_i3++];
        } else {
          _i3 = _iterator3.next();
          if (_i3.done) break;
          _ref3 = _i3.value;
        }

        var key = _ref3;

        keysObj[key] = true;
      }

      return new _ViasPromise2.default(_this, 'bulk', { alias: alias, keys: Object.keys(keysObj).sort() }, options, _constants.ARRAY_SHAPE, exec);
    };

    // Custom operation, request can return in any shape the user defined

    var _loop = function (methodName) {
      if (custom.hasOwnProperty(methodName)) {
        (function () {
          // Shape is function that take remote result and output path(s) to actual doc, return null if result is a single doc
          // Example: {a: doc1, b: doc2, c: {d: doc3}} -> ['a', 'b', 'c.d'] OR doc -> null
          // Action is the actual resolver
          var _custom$methodName = custom[methodName],
              shape = _custom$methodName.shape,
              action = _custom$methodName.action;

          _this[methodName] = function () {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var exec = function () {
              var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              var cb = arguments[1];


              if (_this.cachable) {
                // Try to get from cache first
                var resultFromCache = _this.customResult(methodName, data, shape, options.expiry || 0, options.sync);
                if (resultFromCache) {
                  return cb(null, { alias: resultFromCache.alias, key: resultFromCache.key, result: resultFromCache.result }, resultFromCache.meta);
                }
              }

              if (options.sync) {
                return cb();
              }

              action(data, options, function (err, result, meta) {
                if (err) {
                  return cb(err);
                }

                if (_this.cachable) {

                  var fetchedAt = new Date();
                  var alias = Object.keys(_this.aliases)[0];
                  var aliasPath = _this.aliases[alias];
                  var aliasResult = void 0;
                  var documentPaths = shape(result);
                  if (!documentPaths) {
                    aliasResult = (0, _util.pathValue)(result, aliasPath);
                    _this.save(result, fetchedAt);
                  } else {
                    aliasResult = (0, _util.clone)(result);
                    for (var _iterator4 = documentPaths, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
                      var _ref4;

                      if (_isArray4) {
                        if (_i4 >= _iterator4.length) break;
                        _ref4 = _iterator4[_i4++];
                      } else {
                        _i4 = _iterator4.next();
                        if (_i4.done) break;
                        _ref4 = _i4.value;
                      }

                      var path = _ref4;

                      var doc = (0, _util.pathValue)(result, path);
                      _this.save(doc, fetchedAt);
                      (0, _util.setValueByPath)(aliasResult, path, (0, _util.pathValue)(doc, aliasPath));
                    }
                  }

                  _this.saveCustomResult(methodName, data, alias, aliasResult, meta, fetchedAt);
                  cb(null, { alias: alias, result: aliasResult }, meta);
                  _this._broadcast(_constants.MODEL_CACHE_UPDATED);
                } else {
                  cb(null, { result: result }, meta);
                }
              });
            };
            return new _ViasPromise2.default(_this, methodName, { data: data }, options, shape, exec);
          };
        })();
      }
    };

    for (var methodName in custom) {
      _loop(methodName);
    }
  }

  // Get customer method result from cache


  Model.prototype.customResult = function customResult(method, data, shape, expiry, sync) {
    var cache = this.customResults;
    // Use stable JSON stringify as cacheKey
    var dataKey = (0, _objectHash2.default)(data);
    if (cache[method] && cache[method][dataKey]) {
      var expired = void 0;
      var cacheRecord = cache[method][dataKey];
      if (expiry >= 0 && !sync) {
        expired = new Date(cacheRecord.fetchedAt).getTime() + expiry < new Date().getTime();
      } else {
        expired = false;
      }

      if (!expired) {
        // Refetch if any document passed the expiry
        var aliasPaths = shape(cacheRecord.result);
        if (!aliasPaths) {
          if (!this.fromCache(cacheRecord.alias, cacheRecord.result, expiry, sync)) {
            return null;
          }
        } else {
          for (var _iterator5 = aliasPaths, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
            var _ref5;

            if (_isArray5) {
              if (_i5 >= _iterator5.length) break;
              _ref5 = _iterator5[_i5++];
            } else {
              _i5 = _iterator5.next();
              if (_i5.done) break;
              _ref5 = _i5.value;
            }

            var path = _ref5;

            var key = (0, _util.pathValue)(cacheRecord.result, path);
            if (!this.fromCache(cacheRecord.alias, key, expiry, sync)) {
              return null;
            }
          }
        }
        return cacheRecord;
      }
    }
    return null;
  };

  // Save custom method result to cache


  Model.prototype.saveCustomResult = function saveCustomResult(method, data, alias, result, meta, fetchedAt) {
    var cache = this.customResults;
    var dataKey = (0, _objectHash2.default)(data);
    if (!cache[method]) {
      cache[method] = {};
    }
    // Only save the alias name and the alias, not the actual document
    // Document should be populated using the document cache
    cache[method][dataKey] = { alias: alias, result: result, meta: meta, fetchedAt: fetchedAt };
    this.customResults = cache;
  };

  // Get document from cache


  Model.prototype.fromCache = function fromCache(alias, key, expiry, sync) {
    var cache = this.docs;
    if (cache[alias] && cache[alias][key]) {
      var expired = void 0;
      if (expiry >= 0 && !sync) {
        expired = new Date(cache[alias][key].fetchedAt).getTime() + expiry < new Date().getTime();
      } else {
        expired = false;
      }

      if (!expired) {
        return cache[alias][key].doc;
      }
    }
    return null;
  };

  // Save document to cache


  Model.prototype.save = function save(doc, fetchedAt) {
    var cache = this.docs;
    fetchedAt = fetchedAt || new Date();
    // Cache is indexed by every aliases defined
    for (var alias in this.aliases) {
      if (this.aliases.hasOwnProperty(alias)) {
        var path = this.aliases[alias];
        var key = (0, _util.pathValue)(doc, path);
        if (!(0, _util.isUndefined)(key)) {
          if (!cache[alias]) {
            cache[alias] = {};
          }
          cache[alias][key] = { fetchedAt: fetchedAt, doc: doc };
        } else {
          throw new Error('Alias field ' + path + ' for ' + this.name + ' is not defined');
        }
      }
    }
  };

  // Boradcasting for promise when resolved/updated


  Model.prototype._broadcast = function _broadcast(event) {
    var _loop2 = function () {
      if (_isArray6) {
        if (_i6 >= _iterator6.length) return 'break';
        _ref6 = _iterator6[_i6++];
      } else {
        _i6 = _iterator6.next();
        if (_i6.done) return 'break';
        _ref6 = _i6.value;
      }

      var listener = _ref6;

      setTimeout(function () {
        listener(event);
      });
    };

    for (var _iterator6 = this.listeners, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
      var _ref6;

      var _ret3 = _loop2();

      if (_ret3 === 'break') break;
    }
  };

  Model.prototype.subscribe = function subscribe(listener) {
    this.listeners.push(listener);
  };

  Model.prototype.unsubscribe = function unsubscribe(listener) {
    var index = this.listeners.indexOf(listener);
    if (index > -1) {
      this.listeners.splice(index, 1);
    }
  };

  return Model;
}();

exports.default = Model;


//////////////////
// WEBPACK FOOTER
// ./~/vias/lib/Model.js
// module id = 131
// module chunks = 15